import React from 'react';
import './App.css';
import EmailMessages from './components/emails/EmailMessages';
import NewEmail from './components/emails/NewEmail';
import Overview from './components/Overview';
import Templates from './components/Templates';
import Login from './Login';
import EmailAddresses from './components/emails/EmailAddresses';
import LoginCallback from './LoginCallback';
import NotAuthorized from './components/NotAuthorized';
import SmsMessages from './components/sms/SmsMessages';
import NewSms from './components/sms/NewSms';
import PhoneNumbers from './components/sms/PhoneNumbers';
import SmsTemplates from './components/sms/SmsTemplates';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Navbar from './components/Navbar';
import Sidebar from './components/Sidebar';
import Footer from './Footer';

function PrivateRoute({ children }) {
  const { isAuthenticated, hasOutreachRole, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <div>Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!hasOutreachRole) {
    return <Navigate to="/not-authorized" replace />;
  }

  return children;
}

function AuthenticatedRoute({ children }) {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

// Layout with sidebar + main content for private routes
function SidebarLayout() {
  return (
    <div style={{ display: 'flex', minHeight: 'calc(100vh - 75px)' }}>
      <Sidebar />
      <div style={{ flex: 1, overflow: 'auto', display: 'flex', flexDirection: 'column' }}>
        <div style={{ flex: 1 }}>
          <Outlet />
        </div>
        <Footer />
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <Navbar />
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/login/callback" element={<LoginCallback />} />
          <Route path="/not-authorized" element={<NotAuthorized />} />

          {/* Private routes with sidebar layout */}
          <Route element={
            <PrivateRoute>
              <SidebarLayout />
            </PrivateRoute>
          }>
            <Route path="/" element={<Overview />} />
            <Route path="/email-messages" element={<EmailMessages />} />
            <Route path="/new-email" element={<NewEmail />} />
            <Route path="/email-templates" element={<Templates />} />
            <Route path="/email-addresses" element={<EmailAddresses />} />
            <Route path="/sms-messages" element={<SmsMessages />} />
            <Route path="/new-sms" element={<NewSms />} />
            <Route path="/phone-numbers" element={<PhoneNumbers />} />
            <Route path="/sms-templates" element={<SmsTemplates />} />
          </Route>

          {/* Old overview pages now live on the Overview page; unknown URLs go there too */}
          <Route path="/home" element={<Navigate to="/" replace />} />
          <Route path="/email-overview" element={<Navigate to="/" replace />} />
          <Route path="/sms-overview" element={<Navigate to="/" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;